import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { EmisorService } from 'app/services/emisor.service'; 
import { ChangeDetectorRef } from '@angular/core';
import { CatalogService } from 'app/services/catalog.service';
import { FormBuilder, UntypedFormGroup, Validators,FormControl } from '@angular/forms';
import { FuseConfirmationService } from '@fuse/services/confirmation';

@Component({
  selector: 'app-dialog-synonym',
  templateUrl: './dialog-synonym.component.html',
  styleUrls: ['./dialog-synonym.component.scss']
})
export class DialogSynonymComponent implements OnInit {
  externalForm    : UntypedFormGroup;
  //############################################################
  //############################################################
    constructor(
      @Inject(MAT_DIALOG_DATA) public data: any,
      private _dialogRef: MatDialogRef<DialogSynonymComponent>,
      private _fb: FormBuilder,
      private _emisorService: EmisorService,
      private ref: ChangeDetectorRef,
      private _catalogService: CatalogService,
      private _fuseConfirmationService: FuseConfirmationService,
    ) { 
  
      this.externalForm = this._fb.group({
        synonym: [null,[Validators.required]]
  
  
      })
  
    }
  //############################################################
  //############################################################
    ngOnInit(): void {
  
    }
  //############################################################
  //############################################################
  async closeBtn(): Promise<any> {
    this._dialogRef.close();
  }
  //############################################################
  //############################################################
  async addSynonym(){
    const dialogRef = this._fuseConfirmationService.open({
      title: `Agregar Sinónimo: <b>${this.externalForm.value.synonym}</b>`,
      message: `Producto:<b>${this.data.nameProduct}</b>`,
      icon: {
          show: true,
          name: 'add',
          color: 'primary'
      },
      "actions": {
        "confirm": {
          "show": true,
          "label": "Aceptar",
          "color": "primary"
        },
        "cancel": {
          "show": true,
          "label": "Cancel"
        }
      },
      "dismissible": false      
    });
    dialogRef.afterClosed().subscribe(async (result) => {
      if (result === 'confirmed') {
          ////////////////////////////////////////// 
          let json = { 
              appToken       : null
             ,language       : 'es'
             ,uuidSSO        : null
             ,uuidPsServices : this.data.uuidPsServices 
             ,data      : [  {
                                idPsServicesSynonymName : 0
                               ,synonym                 : this.externalForm.value.synonym
                               ,acction                 : 'ADD'
                            }
                           ]
          }
          await this._catalogService.setPsServicesSynonym(json).then( 
            async (res: any) => {
              if(res.success){
                //this.ngOnInit();
                this._dialogRef.close({refresh:true});
              }
            }
          );
          //////////////////////////////////////////  
      }else{
          //////////////////////////////////////////     
          //await this.reLoadOrder()           
          this._dialogRef.close({refresh:false});
          //////////////////////////////////////////                
      }
    });
  
  }    
  //############################################################
  //############################################################  
  removeSpecialCharacters(event) {
    let newVal = event.target.value.replace('[^A-Za-z,]', '');
    return newVal;
  }
  //############################################################
  //############################################################   
  }